import { useState, useEffect } from 'react';
import Wrapper from '../MentorShipHeaders/Wrapper';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowNarrowLeftIcon } from '@heroicons/react/outline';
import { getMentorshipsByUuid } from '@nx-monorepo/services';
import formatDate from '../../../utils/formatDate';

function ViewMentee() {
  const [details, setDetails] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const getSingleMentorshipDetails = async () => {
    try {
      let response = await getMentorshipsByUuid(location?.state?.itemUuid);
      setDetails(response);
    } catch (error) {
      console.log('error in getting-single-metorship-details', error);
    }
  };

  useEffect(() => {
    getSingleMentorshipDetails();
  }, []);

  return (
    <Wrapper topBarActiveOption={'Events'} active="mentees">
      <div class="mx-5 mt-10 overflow-hidden rounded-lg border bg-white shadow sm:rounded-lg">
        <div class="flex justify-between pr-5">
          <div className="px-4 py-5 sm:px-6">
            <h3 class="text-lg font-medium leading-6 text-gray-900">Mentee</h3>
            <p class="mt-1 max-w-2xl text-sm text-gray-500">
              Mentee details and Information.
            </p>
          </div>
          <div
            className="flex cursor-pointer flex-col items-center justify-center"
            onClick={() => navigate('/mentees')}
          >
            <ArrowNarrowLeftIcon className="h-5 w-5" />
            <p>Back</p>
          </div>
        </div>
        <div class="border-t border-gray-200">
          <dl>
            <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">Event Topic</dt>
              <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                {details?.topic ? details?.topic : '-'}
              </dd>
            </div>
            <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">Event Type</dt>
              <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                {details?.type ? details?.type : '-'}
              </dd>
            </div>
            <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">Mentee Name</dt>
              <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                {details?.data?.name ? details?.data?.name : '-'}
              </dd>
            </div>
            <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">Mentee Date</dt>
              <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                {details?.data?.mentee_date ? details?.data?.mentee_date : '-'}
              </dd>
            </div>
            <div class="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">Mentoring Type</dt>
              <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                {details?.data?.type_of_mentoring
                  ? details?.data?.type_of_mentoring
                  : '-'}
              </dd>
            </div>
            <div class="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt class="text-sm font-medium text-gray-500">Created On</dt>
              <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                {formatDate(new Date(details?.createdAt), 'dmy')}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </Wrapper>
  );
}

export default ViewMentee;
